import Grid from '@mui/material/Grid';
// biome-ignore lint/correctness/noUnusedImports: Automated migration to Biome
import React from 'react';
import { getFrontifyBackgroundImageUrl } from '@/utils/frontify';
import type {
  Contentful,
  FrontifyImageContent,
} from '../../contentful/contentful-exports';
import Button, { type ButtonContent } from '../OldButton/OldButton';
import RichTextSection, {
  type RichTextContent,
} from '../RichText/RichTextSection';
import useStyles from './CalloutContent.styles';

export interface CalloutContentContent extends Contentful {
  fields: {
    body?: RichTextContent;
    backgroundImage?: FrontifyImageContent[];
    backgroundImagePosition: 'top' | 'bottom';
    buttons?: ButtonContent[];
  };
}

interface Props {
  content: CalloutContentContent;
}

/**
 * @deprecated V2 component
 */
export default function CalloutContent({ content }: Props) {
  const { classes } = useStyles();

  const { body, backgroundImage, backgroundImagePosition, buttons } =
    content.fields;

  return (
    <Grid
      container
      className={classes.container}
      style={{
        backgroundImage: backgroundImage
          ? getFrontifyBackgroundImageUrl(backgroundImage[0].preview_url, 1440)
          : '',
        backgroundPositionY: backgroundImagePosition,
      }}
    >
      <Grid className={classes.item} size={12}>
        {body && <RichTextSection content={body} />}
        {buttons && (
          <div className={classes.buttons}>
            {buttons.map((button) => {
              return <Button key={button.sys.id} {...button.fields} />;
            })}
          </div>
        )}
      </Grid>
    </Grid>
  );
}
